import { useTranslation } from 'react-i18next';
import { EnhancedTable } from '../../../common/table/EnhancedTable';
import { HeadCell } from '../../../common/table/EnhancedTableHead';
import { FeatureType, FeatureValueView } from '../../../generated/ApiClient';
import { formatFeatureValue } from '../ClassificationPage.types';

interface FeatureDefinitionRow {
  id: string;
  value?: string;
  name: string;
  featureType: string;
  format?: string;
  isSystem: string;
  sortOrder: number;
  featureId: string;
  originalFeatureType: FeatureType;
}

interface Props {
  featureValues: FeatureValueView[];
  isLoading: boolean;
  handleRowClick: (e: React.MouseEvent<unknown>, id: string) => void;
}

export function FeatureValueList({ featureValues, isLoading, handleRowClick }: Props) {
  const { t } = useTranslation();

  const headCells: readonly HeadCell<FeatureDefinitionRow>[] = [
    {
      id: 'name',
      disablePadding: false,
      label: t('classification.features.name'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'value',
      disablePadding: false,
      label: t('classification.features.value'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'featureType',
      disablePadding: false,
      label: t('classification.features.type'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'format',
      disablePadding: false,
      label: t('classification.features.format'),
      allowSorting: true,
      allowFiltering: true,
    },
    {
      id: 'isSystem',
      disablePadding: false,
      label: t('classification.features.isSystem'),
      allowSorting: true,
      allowFiltering: true,
    },
  ];

  const rows = featureValues.map((x) => ({
    ...x,
    id: x.featureId,
    name: x.name,
    originalFeatureType: x.featureType,
    featureType: t(`classification.features.types.${x.featureType}`),
    value: formatFeatureValue(x.featureType, x.value),
    isSystem: x.isSystem ? t('yes') : t('no'),
  }));

  return (
    <EnhancedTable
      rows={rows}
      loading={isLoading}
      headCells={headCells}
      hideCheckbox={true}
      variant="default"
      onRowClick={handleRowClick}
    />
  );
}
